<template>
  <SearchBasicLayout>
    <div class='plan text-cg-black'>
      <!-- 合作流程說明(置頂 hero):詢問 → LINE 轉發 → 回覆 → 成交閉環,強化綁 LINE 誘因 -->
      <section class="relative overflow-hidden px-[24px] pt-[64px] pb-[64px] sm:pt-[40px] sm:pb-[44px]">
        <div class="absolute inset-0 bg-gradient-to-b from-[#EAF1FB] to-white pointer-events-none"></div>
        <div class="relative md:max-w-[1040px] mx-auto text-cg-black">
          <p class="text-center text-[#7593C1] font-bold tracking-[0.2em] text-[15px] sm:text-[12px] mb-[10px]">
            上架空間 · 線上接單
          </p>
          <h1 class="text-center font-extrabold text-[34px] sm:text-[24px] leading-tight mb-[14px]">
            上架後，我們怎麼幫你接到生意？
          </h1>
          <p class="text-center text-[17px] sm:text-[14px] text-[#707070] mb-[44px] sm:mb-[28px]">
            平台與場地主的所有溝通都透過 LINE 進行，<br class="sm:hidden">租客的每一筆詢問，都會即時送到你的 LINE。
          </p>

          <div class="flex sm:flex-col items-stretch justify-center gap-[8px] mb-[36px]">
            <template v-for="(step, idx) in coopSteps"
                      :key="'coop-' + idx">
              <div class="flex-1 bg-white rounded-3xl shadow-[0_10px_30px_rgba(15,23,42,0.08)] p-[28px] sm:p-[22px]
                          flex flex-col items-center text-center transition duration-200
                          hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(15,23,42,0.14)]">
                <div class="relative mb-[16px]">
                  <div class="w-[76px] h-[76px] rounded-full bg-gradient-to-br from-[#7593C1] to-[#16427F]
                              flex items-center justify-center text-[34px] shadow-md">{{ step.icon }}</div>
                  <span class="absolute -top-[6px] -right-[6px] w-[26px] h-[26px] rounded-full bg-[#F7C767]
                               text-cg-black text-[14px] font-extrabold flex items-center justify-center shadow">{{ idx + 1 }}</span>
                </div>
                <h3 class="font-extrabold text-[19px] sm:text-[17px] mb-[6px]">{{ step.title }}</h3>
                <p class="text-[15px] sm:text-[14px] text-[#707070] leading-relaxed">{{ step.text }}</p>
              </div>
              <div v-if="idx < coopSteps.length - 1"
                   class="flex items-center justify-center text-[#7593C1] text-[30px] font-bold px-[2px] sm:rotate-90 sm:py-[2px]">
                ›
              </div>
            </template>
          </div>

          <div class="flex items-center justify-center gap-[10px] bg-[#FFF7ED] border border-[#FED7AA]
                      rounded-2xl px-[28px] py-[18px] sm:px-[20px]">
            <span class="text-[22px] shrink-0">🔔</span>
            <p class="text-[16px] sm:text-[14px] font-bold text-[#C2410C] leading-relaxed">
              沒綁定 LINE 就收不到詢問通知，等於漏接上門的生意 — 註冊後第一件事，記得綁定 LINE。
            </p>
          </div>
        </div>
      </section>

      <div class='px-[5px] py-[40px] relative text-cg-black'>

        <!--        手機版-->
        <div class="sm:block hidden">
          <TabGroup :defaultIndex="tabSelect">
<!--             <TabList
                class="w-full grid grid-cols-3 mb-2 text-[20px] font-extrabold text-[#707070] text-center">
              <Tab v-slot="{ selected }">
                <div class="border-b-[20px] outline-none"
                     :class="selected ? 'border-[#7593C1] text-[#222222]':' border-[#F4F4F4]'">專業方案
                </div>
              </Tab>
              <Tab v-slot="{ selected }">
                <div class="border-b-[20px] outline-none"
                     :class="selected ? 'border-[#F7C767] text-[#222222]':' border-[#F4F4F4]'">優選方案
                </div>
              </Tab>
              <Tab v-slot="{ selected }">
                <div class="border-b-[20px] outline-none"
                     :class="selected ? 'border-[#DE9393] text-[#222222]':' border-[#F4F4F4]'">尊享方案
                </div>
              </Tab>
            </TabList> -->

            <TabPanels class="py-[24px] px-8">
              <TabPanel v-for="(plan, idx) in plans"
                        :key="'plan-' + idx">
                <div class="border-[7px] p-[40px] bg-white relative rounded-2xl shadow-xl w-full"
                     :class="plan.borderColor">
                  <PlanCard :planName="plan.name"
                            :planCharge="plan.charge"
                            :chargePeriod="plan.chargePeriod"
                            :upFee="plan.upFee"
                            :original-server-fee="plan.originalServerFee"
                            :serverFee="plan.serverFee"
                            :planNameColor="plan.planNameColor"
                            :planId="plan.planId"
                            :buttonColor="plan.buttonColor"
                            :buttonText="plan.buttonText"
                            :buttonCallback="() => plan.buttonCallback(this)"
                            :line-url="plan.lineUrl"
                            :line-callback="plan.lineCallback"
                            :web-label="plan.webLabel"
                            :web-callback="plan.webCallback"
                            :planFeatures="plan.planFeatures"
                            :add-on-features="plan.addOnFeatures"
                            :comments="plan.comments"
                            :server-fee-description="plan.serverFeeDescription"
                  />
                  <br/><br/>
                  <ul class="absolute bottom-0 h-16 w-[75%]">
                    <li v-for="(text, idx) in plan.comments"
                        :key="'comment-' + idx"
                        class="text-[12px] text-[#A5A6A7]"
                    > {{ text }}
                    </li>
                  </ul>
                </div>
              </TabPanel>

            </TabPanels>

          </TabGroup>

        </div>

        <!--        pc 版-->
        <div class="px-10 grid grid-cols-1 gap-[20px] md:max-w-[90%] xl:max-w-[80%] 2xl:max-w-[70%] pc:mx-auto">
          <div v-for="(plan, idx) in plans"
               :key="'plan-' + idx"
               class="border-[7px] bg-white relative rounded-xl
            shadow-xl 
            sm:hidden block"
               :class="plan.borderColor">
            <div class="p-[39px] h-full"
                 :class="plan.borderExtra">
              <PlanCard :planName="plan.name"
                        :planCharge="plan.charge"
                        :chargePeriod="plan.chargePeriod"
                        :upFee="plan.upFee"
                        :original-server-fee="plan.originalServerFee"
                        :serverFee="plan.serverFee"
                        :planNameColor="plan.planNameColor"
                        :planId="plan.planId"
                        :buttonColor="plan.buttonColor"
                        :buttonText="plan.buttonText"
                        :buttonCallback="() => plan.buttonCallback(this)"
                        :line-url="plan.lineUrl"
                        :line-callback="plan.lineCallback"
                        :web-label="plan.webLabel"
                        :web-callback="plan.webCallback"
                        :planFeatures="plan.planFeatures"
                        :add-on-features="plan.addOnFeatures"
                        :comments="plan.comments"
                        :server-fee-description="plan.serverFeeDescription"
              />

              <br/><br/>
              <ul class="absolute bottom-0 h-16 w-[75%]">
                <li v-for="(text, idx) in plan.comments"
                    :key="'comment-' + idx"
                    class="text-[12px] text-[#A5A6A7]"
                > {{ text }}
                </li>
              </ul>

            </div>
          </div>
          <div class="absolute top-[90px] -right-[10px] pointer-events-none">
            <img src='/assets/img/plan/paper_airplane.svg'/></div>
          <div class="absolute bottom-[20px] -right-[50px]"><img src='/assets/img/plan/man2 1.png'/></div>
        </div>

        <!-- popup window -->
        <el-dialog
            v-model="showPopup"
            class="flex justify-center"
            width="355px"
            :show-close="false"
            align-center
            style="border-radius: 1.5rem;">

          <h2 class="font-extrabold text-[20px]">連絡我們</h2>
          <div class='flex justify-between lg:justify-center text-center items-center mt-8'>
            <a class="cursor-pointer mr-[100px]"
               href="line://ti/p/@768cpmhz?oat_referrer=PROFILE"
               target="_blank">
              <svg width="100"
                   height="100"
                   viewBox="0 0 32 32"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16ZM26.1333 15.4158C26.1333 11.0326 21.7073 7.46667 16.2666 7.46667C10.8266 7.46667 6.4 11.0326 6.4 15.4158C6.4 19.3453 9.91016 22.6362 14.6516 23.2585C14.973 23.3272 15.4103 23.4688 15.521 23.7415C15.6205 23.9892 15.586 24.3771 15.5527 24.6273C15.5527 24.6273 15.437 25.3185 15.412 25.4657C15.3691 25.7134 15.2138 26.4343 16.2666 25.9937C17.3197 25.5532 21.9489 22.6721 24.0189 20.3066C25.4488 18.7499 26.1333 17.1701 26.1333 15.4158Z"
                      fill="#222222"/>
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.2096 13.3333H13.5239C13.4188 13.3333 13.3333 13.4215 13.3333 13.5299V17.9367C13.3333 18.0453 13.4188 18.1333 13.5239 18.1333H14.2096C14.3147 18.1333 14.4 18.0453 14.4 17.9367V13.5299C14.4 13.4215 14.3147 13.3333 14.2096 13.3333Z"
                      fill="#222222"/>
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.9996 13.3333H18.2777C18.1671 13.3333 18.0773 13.4215 18.0773 13.5299V16.148L16.0225 13.4208C16.0178 13.4138 16.0124 13.4072 16.0069 13.4008L16.0055 13.3996C16.0016 13.3952 15.9976 13.3913 15.9935 13.3874C15.9923 13.3863 15.9911 13.3853 15.9897 13.3841C15.9864 13.381 15.9828 13.3781 15.9791 13.3754C15.9775 13.3739 15.9757 13.3727 15.974 13.3713C15.9704 13.369 15.9671 13.3665 15.9635 13.3644C15.9615 13.363 15.9596 13.3618 15.9574 13.3609C15.9538 13.3587 15.9503 13.3566 15.9467 13.3549C15.9446 13.3539 15.9426 13.3527 15.9404 13.3519C15.9367 13.3502 15.9329 13.3485 15.929 13.3471C15.9266 13.3463 15.9246 13.3455 15.9225 13.3448C15.9185 13.3434 15.9146 13.3421 15.9104 13.3411C15.9083 13.3403 15.9059 13.3399 15.9035 13.3391C15.8996 13.3384 15.8958 13.3374 15.8921 13.3366C15.8893 13.3362 15.8864 13.3359 15.8836 13.3357C15.8801 13.3349 15.8765 13.3347 15.873 13.3343C15.8696 13.3339 15.8662 13.3339 15.8627 13.3337C15.8601 13.3337 15.8582 13.3333 15.8556 13.3333H15.134C15.0233 13.3333 14.9333 13.4215 14.9333 13.5299V17.9367C14.9333 18.0453 15.0233 18.1333 15.134 18.1333H15.8556C15.9665 18.1333 16.0562 18.0453 16.0562 17.9367V15.3194L18.1136 18.0502C18.1278 18.0699 18.1454 18.086 18.1645 18.0988C18.1651 18.0992 18.1659 18.0998 18.1665 18.1004C18.1706 18.1029 18.1748 18.1054 18.1789 18.1077C18.1809 18.1089 18.1827 18.1097 18.1846 18.1106C18.1876 18.1124 18.1909 18.1139 18.1941 18.1153C18.1974 18.1167 18.2004 18.118 18.204 18.1194C18.2059 18.1202 18.2079 18.1209 18.2099 18.1215C18.2146 18.1233 18.219 18.1246 18.2235 18.126C18.2245 18.126 18.2255 18.1264 18.2264 18.1265C18.2428 18.1308 18.26 18.1333 18.2777 18.1333H18.9996C19.1104 18.1333 19.2 18.0453 19.2 17.9367V13.5299C19.2 13.4215 19.1104 13.3333 18.9996 13.3333Z"
                      fill="#222222"/>
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.6051 17.0298H10.694V13.5303C10.694 13.4215 10.6065 13.3333 10.4989 13.3333H9.7953C9.68746 13.3333 9.6 13.4215 9.6 13.5303V17.9362C9.6 17.9891 9.62095 18.0374 9.65459 18.0727C9.65536 18.0736 9.65613 18.0746 9.65728 18.0756C9.65824 18.0765 9.65921 18.0773 9.66017 18.0783C9.69534 18.1124 9.74263 18.1333 9.79511 18.1333H12.6051C12.7129 18.1333 12.8 18.0449 12.8 17.9362V17.2268C12.8 17.118 12.7129 17.0298 12.6051 17.0298Z"
                      fill="#222222"/>
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M22.7384 14.4368C22.8463 14.4368 22.9333 14.3488 22.9333 14.2399V13.5305C22.9333 13.4217 22.8463 13.3333 22.7384 13.3333H19.9286C19.876 13.3333 19.8281 13.3547 19.7929 13.389C19.7922 13.3897 19.7912 13.3903 19.7906 13.3911C19.7895 13.3923 19.7885 13.3934 19.7875 13.3946C19.7541 13.4299 19.7333 13.4776 19.7333 13.5303V17.9364C19.7333 17.9893 19.7543 18.0374 19.7879 18.0727C19.7887 18.0736 19.7897 18.0748 19.7906 18.0756C19.7914 18.0765 19.7925 18.0775 19.7935 18.0783C19.8285 18.1122 19.876 18.1333 19.9283 18.1333H22.7384C22.8463 18.1333 22.9333 18.0449 22.9333 17.9364V17.2268C22.9333 17.1182 22.8463 17.0298 22.7384 17.0298H20.8275V16.285H22.7384C22.8463 16.285 22.9333 16.1968 22.9333 16.088V15.3787C22.9333 15.2699 22.8463 15.1815 22.7384 15.1815H20.8275V14.4368H22.7384Z"
                      fill="#222222"/>
              </svg>
            </a>
            <img width="120"
                 height="120"
                 src="https://qr-official.line.me/gs/M_768cpmhz_GW.png?oat_content=qr">
          </div>
          <div class="py-5"></div>
          <button class="w-[320px] h-[55px] rounded-full bg-[#7593C1] hover:bg-[#16427F]
            text-white text-[16px] font-bold"
                  :onclick="() => showPopup=false">確定
          </button>

        </el-dialog>
        <!--      <div class="fixed w-full h-[320px] top-[30%] left-0 flex text-center justify-center">
                <div class="bg-white h-[320px] shadow-xl py-5 rounded-2xl px-5">
                  <h2 class="font-extrabold text-[20px]">連絡我們</h2>
                  <div class='flex justify-between lg:justify-center text-center items-center mt-8'>
                    <a class="cursor-pointer mr-[100px]"
                      href="line://ti/p/@768cpmhz?oat_referrer=PROFILE"
                      target="_blank">
                    <svg width="100" height="100" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16ZM26.1333 15.4158C26.1333 11.0326 21.7073 7.46667 16.2666 7.46667C10.8266 7.46667 6.4 11.0326 6.4 15.4158C6.4 19.3453 9.91016 22.6362 14.6516 23.2585C14.973 23.3272 15.4103 23.4688 15.521 23.7415C15.6205 23.9892 15.586 24.3771 15.5527 24.6273C15.5527 24.6273 15.437 25.3185 15.412 25.4657C15.3691 25.7134 15.2138 26.4343 16.2666 25.9937C17.3197 25.5532 21.9489 22.6721 24.0189 20.3066C25.4488 18.7499 26.1333 17.1701 26.1333 15.4158Z" fill="#222222"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2096 13.3333H13.5239C13.4188 13.3333 13.3333 13.4215 13.3333 13.5299V17.9367C13.3333 18.0453 13.4188 18.1333 13.5239 18.1333H14.2096C14.3147 18.1333 14.4 18.0453 14.4 17.9367V13.5299C14.4 13.4215 14.3147 13.3333 14.2096 13.3333Z" fill="#222222"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9996 13.3333H18.2777C18.1671 13.3333 18.0773 13.4215 18.0773 13.5299V16.148L16.0225 13.4208C16.0178 13.4138 16.0124 13.4072 16.0069 13.4008L16.0055 13.3996C16.0016 13.3952 15.9976 13.3913 15.9935 13.3874C15.9923 13.3863 15.9911 13.3853 15.9897 13.3841C15.9864 13.381 15.9828 13.3781 15.9791 13.3754C15.9775 13.3739 15.9757 13.3727 15.974 13.3713C15.9704 13.369 15.9671 13.3665 15.9635 13.3644C15.9615 13.363 15.9596 13.3618 15.9574 13.3609C15.9538 13.3587 15.9503 13.3566 15.9467 13.3549C15.9446 13.3539 15.9426 13.3527 15.9404 13.3519C15.9367 13.3502 15.9329 13.3485 15.929 13.3471C15.9266 13.3463 15.9246 13.3455 15.9225 13.3448C15.9185 13.3434 15.9146 13.3421 15.9104 13.3411C15.9083 13.3403 15.9059 13.3399 15.9035 13.3391C15.8996 13.3384 15.8958 13.3374 15.8921 13.3366C15.8893 13.3362 15.8864 13.3359 15.8836 13.3357C15.8801 13.3349 15.8765 13.3347 15.873 13.3343C15.8696 13.3339 15.8662 13.3339 15.8627 13.3337C15.8601 13.3337 15.8582 13.3333 15.8556 13.3333H15.134C15.0233 13.3333 14.9333 13.4215 14.9333 13.5299V17.9367C14.9333 18.0453 15.0233 18.1333 15.134 18.1333H15.8556C15.9665 18.1333 16.0562 18.0453 16.0562 17.9367V15.3194L18.1136 18.0502C18.1278 18.0699 18.1454 18.086 18.1645 18.0988C18.1651 18.0992 18.1659 18.0998 18.1665 18.1004C18.1706 18.1029 18.1748 18.1054 18.1789 18.1077C18.1809 18.1089 18.1827 18.1097 18.1846 18.1106C18.1876 18.1124 18.1909 18.1139 18.1941 18.1153C18.1974 18.1167 18.2004 18.118 18.204 18.1194C18.2059 18.1202 18.2079 18.1209 18.2099 18.1215C18.2146 18.1233 18.219 18.1246 18.2235 18.126C18.2245 18.126 18.2255 18.1264 18.2264 18.1265C18.2428 18.1308 18.26 18.1333 18.2777 18.1333H18.9996C19.1104 18.1333 19.2 18.0453 19.2 17.9367V13.5299C19.2 13.4215 19.1104 13.3333 18.9996 13.3333Z" fill="#222222"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6051 17.0298H10.694V13.5303C10.694 13.4215 10.6065 13.3333 10.4989 13.3333H9.7953C9.68746 13.3333 9.6 13.4215 9.6 13.5303V17.9362C9.6 17.9891 9.62095 18.0374 9.65459 18.0727C9.65536 18.0736 9.65613 18.0746 9.65728 18.0756C9.65824 18.0765 9.65921 18.0773 9.66017 18.0783C9.69534 18.1124 9.74263 18.1333 9.79511 18.1333H12.6051C12.7129 18.1333 12.8 18.0449 12.8 17.9362V17.2268C12.8 17.118 12.7129 17.0298 12.6051 17.0298Z" fill="#222222"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7384 14.4368C22.8463 14.4368 22.9333 14.3488 22.9333 14.2399V13.5305C22.9333 13.4217 22.8463 13.3333 22.7384 13.3333H19.9286C19.876 13.3333 19.8281 13.3547 19.7929 13.389C19.7922 13.3897 19.7912 13.3903 19.7906 13.3911C19.7895 13.3923 19.7885 13.3934 19.7875 13.3946C19.7541 13.4299 19.7333 13.4776 19.7333 13.5303V17.9364C19.7333 17.9893 19.7543 18.0374 19.7879 18.0727C19.7887 18.0736 19.7897 18.0748 19.7906 18.0756C19.7914 18.0765 19.7925 18.0775 19.7935 18.0783C19.8285 18.1122 19.876 18.1333 19.9283 18.1333H22.7384C22.8463 18.1333 22.9333 18.0449 22.9333 17.9364V17.2268C22.9333 17.1182 22.8463 17.0298 22.7384 17.0298H20.8275V16.285H22.7384C22.8463 16.285 22.9333 16.1968 22.9333 16.088V15.3787C22.9333 15.2699 22.8463 15.1815 22.7384 15.1815H20.8275V14.4368H22.7384Z" fill="#222222"/>
                    </svg>
                    </a>
                    <img width="120" height="120"  src="https://qr-official.line.me/gs/M_768cpmhz_GW.png?oat_content=qr">
                  </div>
                  <div class="py-5"></div>
                  <button class="w-[350px] h-[55px] rounded-full bg-[#7593C1] hover:bg-[#16427F]
                    text-white text-[16px] font-bold"
                    :onclick="() => showPopup=false">確定</button>
                </div>
              </div>-->
      </div>
    </div>
  </SearchBasicLayout>
</template>

<script>
definePageMeta(
    {title: '場地主方案'}
)
import SplitBar from '@/components/Host/SplitBar.vue'
import ExpandText from '@/components/Host/ExpandText.vue'
import PlanCard from '@/components/Host/PlanCard.vue'
import SearchBasicLayout from '~/layouts/searchBasicLayout.vue'
import {TabGroup, TabList, Tab, TabPanels, TabPanel} from '@headlessui/vue'


function handleClickStartUse(planId) {
  const backstageUrl = import.meta.env.VITE_APP_BASE_BACKSTAGE_URL
  const URL = `${backstageUrl}register?plan=${planId}`
  window.open(URL, '_blank')
}

// LN-2:場地主註冊主推 LINE。用 oaMessage 深連結預填一句標記訊息 → 使用者送出後 bot 直接回
// 場地主 onboarding(綁定/註冊入口)。這是「從 host/plan 來」的唯一可靠來源訊號(LINE 加好友事件
// 不帶來源)。標記字串須與 ai-support bot.py 的 PLAN_OWNER_MARKER 完全一致。env 缺 OA id → 退回單鈕(純網頁)。
const ownerLineOaId = import.meta.env.VITE_APP_LINE_OA_ID || ''
const OWNER_ONBOARD_MSG = '我想免費刊登場地、成為場地主'
const ownerLineAddUrl = ownerLineOaId
  ? `https://line.me/R/oaMessage/${ownerLineOaId}/?${encodeURIComponent(OWNER_ONBOARD_MSG)}`
  : ''

// LINE 主鈕的 plan 歸因走 GA(add-friend deep link 無法把 ?plan= 傳進 bot);網頁次連結仍帶 ?plan=。
function trackOwnerLineClick(planId) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({event: 'owner_line_click', plan_id: planId, source: 'host_plan'})
}


export default defineNuxtComponent({
  head() {
    return {
      title: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
      meta: [
        {
          name: 'description',
          content: '空間便利店是一個線上的場地租借平台。我們提供線上預約，省去聯絡，方便又順利。活動空間、會議室，攝影棚、餐廳包廂、聚會場地都可預約'
        },
        {name: 'keywords', content: '場地租借、會議室、攝影棚、廚房租借、活動空間、餐廳包廂、聚會場地，都可線上預約'},
        {property: 'og:title', content: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約'},
        {property: 'og:site_name', content: '空間便利店'},
        {
          property: 'og:description',
          content: '空間便利店是一個線上的場地租借平台！我們提供線上預約，省去聯絡，方便又順利。活動空間、會議室，攝影棚、餐廳包廂、聚會場地都可預約'
        },
        {property: 'og:image', content: 'https://pic.onestep.place/images/onestep-og.png'},
        {
          property: 'og:image:alt',
          content: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約'
        },
        {property: 'og:url', content: 'https://www.onestep.place/host/plan'},
        {property: 'og:type', content: 'website'}
      ]
    };
  },
  components: {
    SearchBasicLayout,
    SplitBar,
    ExpandText,
    PlanCard,
    TabGroup,
    TabList,
    Tab,
    TabPanels,
    TabPanel
  },
  data: () => {
    return {
      tabSelect: 0, // mobile only
      commentA: false,
      showPopup: false,
      coopSteps: [
        { icon: '🔍', title: '租客發出詢問', text: '租客在平台看到你的空間，直接送出詢問。' },
        { icon: '🔔', title: 'LINE 即時通知', text: '平台立刻把這筆詢問透過 LINE 轉發給你。' },
        { icon: '💬', title: '你在 LINE 回覆', text: '直接在 LINE 上回覆，租客馬上收到回應。' },
        { icon: '🤝', title: '敲定成交', text: '雙方在 LINE 持續溝通，敲定看場與成交。' }
      ],
      plans: [
        {
          name: '專業方案',
          charge: '免費上架',
          upFee: '',
          originalServerFee: '',
          serverFee: '',
          planId: '1',
          serverFeeDescription: '',
          borderColor: 'border-[#7593C1]',
          planNameColor: 'text-[#7593C1]',
          buttonText: ownerLineAddUrl ? '用 LINE 開始 · 免費刊登' : '開始使用',
          buttonCallback: () => handleClickStartUse('1'),
          lineUrl: ownerLineAddUrl,
          lineCallback: () => trackOwnerLineClick('1'),
          webLabel: '或用網頁註冊 →',
          webCallback: () => handleClickStartUse('1'),
          buttonColor: 'bg-white border-[#222222] border-2 hover:bg-cg-deep-blue hover:border-cg-blue hover:text-white active:bg-cg-blue active:text-white active:border-cg-blue',
          planFeatures: [
            {
              name: '',
              hasCheck: true,
              items: ['平台免費曝光', '最新場地輪播']
            },
            // {
            //   name: '黃金版位',
            //   hasCheck: true,
            //   items: ['最新場地輪播']
            // },
/*             {
              name: '專屬線上預約系統',
              hasCheck: true,
              items: ['一頁式網站']
            }, */
            // {name: '平台曝光及預訂', hasCheck: true, items: ['會員平台預訂', '平台免費曝光']},
            // {name: '會員付款方式', hasCheck: true, items: ['線上付全款']},
            // {name: '發票及金流', hasCheck: true, items: ['自動寄送電子發票', '自動串接金流']},
            // {name: '訂單管理', hasCheck: true, items: ['訂單簡訊通知', '訂單Email通知', '訂單查詢管理', '營運報表']}
          ],
          addOnFeatures: [
            {
              name: '購買版位',
              hasCheck: true,
              items: ['首頁Banner', '縣市優先版位', '用途優先版位', '首頁空間專區', '平台置入報導'],
              contact: null
            }
          ],
          comments: ['']
        }
      ],

    }
  },
  created() {
    this.plans.forEach(plan => {
      plan.addOnFeatures.forEach(feature => {
        feature.contact = this.togglePopup;
      });
    });
  },
  methods: {
    togglePopup() {
      this.showPopup = true;
    }
  }
})
</script>
